import { IBusinessState, IBusinessUser } from '@/@types'

const state: IBusinessState = {
  businessUser: null,
  invitationInfo: null,
  businessInvitationId: '',
}

export default state
